import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  AuthRoutes,
  RouteParamsTypes,
  Modules,
  NonAuthRoutes,
  PermissionModulesEnum,
  PermissionActionsEnum,
} from '../enums';
import { MenuTextMapping } from '../utils/appConstant';
import { redirectBasedOnPermission } from '../utils/methods';
import { AuthContext } from '../contexts/AuthContext';
import ProtectedRoute from '../components/ProtectedRoute';
import UserList from '../modules/resources/users/list';
import UserAddEditView from '../modules/resources/users/addEditView';

import StockistList from '../modules/resources/stockists/list';
import StockistAddEditView from '../modules/resources/stockists/addEditView';

const Resources: React.FC = () => {
  const { isSystemAdmin, permissions } = useContext(AuthContext);
  return (
    <Routes>
      <Route path={AuthRoutes.users}>
        <Route
          path={AuthRoutes.users + RouteParamsTypes.blank}
          element={
            <ProtectedRoute
              component={UserList}
              accessibleTo={[{ [PermissionModulesEnum.Users]: [PermissionActionsEnum.View] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.users + RouteParamsTypes.add}
          element={
            <ProtectedRoute
              component={UserAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Users]: [PermissionActionsEnum.Add] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.users + RouteParamsTypes.edit + RouteParamsTypes.id}
          element={
            <ProtectedRoute
              component={UserAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Users]: [PermissionActionsEnum.Update] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.users + RouteParamsTypes.view + RouteParamsTypes.id}
          element={
            <ProtectedRoute
              component={UserAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Users]: [PermissionActionsEnum.View] }]}
            />
          }
        />
      </Route>

      <Route path={AuthRoutes.stockists}>
        <Route
          path={AuthRoutes.stockists + RouteParamsTypes.blank}
          element={
            <ProtectedRoute
              component={StockistList}
              accessibleTo={[{ [PermissionModulesEnum.Stockists]: [PermissionActionsEnum.View] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.stockists + RouteParamsTypes.add}
          element={
            <ProtectedRoute
              component={StockistAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Stockists]: [PermissionActionsEnum.Add] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.stockists + RouteParamsTypes.edit + RouteParamsTypes.id}
          element={
            <ProtectedRoute
              component={StockistAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Stockists]: [PermissionActionsEnum.Update] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.stockists + RouteParamsTypes.view + RouteParamsTypes.id}
          element={
            <ProtectedRoute
              component={StockistAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Stockists]: [PermissionActionsEnum.View] }]}
            />
          }
        />
      </Route>

      <Route
        path={RouteParamsTypes.blank}
        element={
          <Navigate
            replace
            to={{
              pathname:
                redirectBasedOnPermission(isSystemAdmin, permissions, MenuTextMapping.resources) ||
                Modules.error + NonAuthRoutes.forbidden,
            }}
          />
        }
      />
      <Route
        path={RouteParamsTypes.any}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
    </Routes>
  );
};

export default Resources;
